<template>
    <div class="devices-list__block" v-if="deviceData" @click="openLightingHistory">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
            <div class="btn-group">
                <v-flex class="btn-block">
                    <div class="d-inline-flex" v-if="deviceData.state != null" @click.stop.prevent>
                        <v-switch
                            v-model="deviceData.state.value"
                            inset
                            dense
                            hide-details
                            class="pa-0"
                            @click="changeDeviceState"
                            :loading="loading"
                            :disabled="deviceData.disabled"
                            color="#FF8484"
                            v-if="free"
                        ></v-switch>
                        <device-switch-disabled :device-state="deviceData.state" :name="deviceData.uid" v-else :not-free="!free"></device-switch-disabled>
                    </div>
                </v-flex>
            </div>
        </v-layout>
        <ModalLightingHistory v-model="openModal" :history="history"></ModalLightingHistory>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
import ModalLightingHistory from "@/components/modals/ModalLightingHistory";
import ModalWaiting from "@/components/modals/ModalWaiting";

export default {
    name: "LightingDevice",
    components: {ModalLightingHistory, ModalWaiting},
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        free: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            loading: false,
            disabledTimeout: null,
            openModal: false,
            history: [],
        };
    },
    created() {
        this.deviceData = this.device;
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
    },
    methods: {
        changeDeviceState() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
                this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/hotel-admin/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
                    this.loading = false;
                    console.log(error);
                });
        },
        openLightingHistory() {
            if (this.deviceData && this.deviceData.uid) {
                this.$refs.modalWaiting.open();
                this.$http.get('/devices/hotel-admin/lighting-on-off-history/' + this.deviceData.uid + '/')
                    .then((response) => {
                        this.history = response.data.actions;
                        this.openModal = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$refs.modalWaiting.close();
                    });
            }
        },
    },
}
</script>